// indexedDBThumbnails.js
const DB_NAME = "thumbnailDB";
const DB_VERSION = 1;
const STORE_NAME = "thumbnails";

// Open or create the IndexedDB
function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = (event) => reject(event.target.error);
    request.onsuccess = (event) => resolve(event.target.result);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

// Save blob with a key
export async function saveThumbnailToIndexedDB(id, blob) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  tx.objectStore(STORE_NAME).put(blob, id);
  await tx.complete?.catch?.(() => {}); // Optional: for backward compat
  db.close();
}

// Retrieve blob by key
export async function getThumbnailFromIndexedDB(id) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readonly");
  const store = tx.objectStore(STORE_NAME);
  const request = store.get(id);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error);
    tx.oncomplete = () => db.close();
  });
}

export async function deleteOldThumbnails(id, currentTimestamp, size) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);
  const request = store.openCursor();

  console.log('deleting cacheKey:', `${id}_${currentTimestamp}_${size}`.slice(-35));

  return new Promise((resolve) => {
    request.onsuccess = (event) => {
      const cursor = event.target.result;
      if (cursor) {
        const key = cursor.key;
        const prefix = `${id}_`;
        const suffix = `_${size}`;
        if (key.startsWith(prefix) && key.endsWith(suffix)) {
          const timestampPart = key.slice(prefix.length, key.length - suffix.length);
          const parsedTimestamp = parseInt(timestampPart, 10);
          if (!isNaN(parsedTimestamp) && parsedTimestamp !== currentTimestamp) {
            console.log(`Deleting stale cache: ${key.slice(-35)}`);
            store.delete(key);
          } else {
            console.log(`No stale cache to be deleted`);
          }
        }
        cursor.continue();
      } else {
        db.close();
        resolve();
      }
    };
    request.onerror = () => {
      db.close();
      resolve(); // silently ignore errors
    };
  });
}

export async function clearThumbnails() {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  tx.objectStore(STORE_NAME).clear();
  await tx.complete?.catch?.(() => {});
  db.close();
}

